/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zaGFyZWQvdWkvYWRkcmVzcy9hZGRyZXNzLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL3NoYXJlZC91aS9hZGRyZXNzL2FkZHJlc3MuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/address/address.component.css.shim.ngstyle.ts